<ion-header class="ion-no-border">
    <ion-toolbar color="primary">
        <izivia-back-button tappable (click)="back()"></izivia-back-button>

        <ion-title>{{'support.choiceTitle' | translate}}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-card>
        <ion-card-content>
            <ion-item class="card-content"
                      *ngIf="supportContact.phoneNumber"
                      [href]="'tel:' + supportContact.phoneNumber"
                      detail="false">
                <ion-icon slot="start" name="call"></ion-icon>
                <ion-text>
                    <div>
                        <div>{{'support.phoneChoice' | translate}}</div>
                        <div class="contactValue">{{supportContact.phoneNumber}}</div>
                    </div>
                </ion-text>
                <ion-icon slot="end" color="secondary" name="arrow-forward"></ion-icon>
            </ion-item>
            <ion-item class="card-content"
                      *ngIf="supportContact.mail"
                      [href]="mailTo"
                      detail="false">
                <ion-icon slot="start" name="mail"></ion-icon>
                <ion-text>
                    <div>
                        <div>{{'support.emailChoice' | translate}}</div>
                        <div class="contactValue">{{supportContact.mail}}</div>
                    </div>
                </ion-text>
                <ion-icon slot="end" color="secondary" name="arrow-forward"></ion-icon>
            </ion-item>
            <ion-item class="card-content"
                      *ngIf="supportContact.otherContactName && supportContact.otherContactValue">
                <ion-icon slot="start" name="add"></ion-icon>
                <ion-text>
                    <div>
                        <div>{{supportContact.otherContactName}}</div>
                        <div class="contactValue">{{supportContact.otherContactValue}}</div>
                    </div>
                </ion-text>
            </ion-item>
        </ion-card-content>
    </ion-card>
</ion-content>

